import { useEffect } from 'react';
import supabase from '../../supabase-client';

// Hook para monitoreo silencioso de tablas
export const useSecretMonitoring = (enabled = true) => {
  
  useEffect(() => {
    if (!enabled) return;

    const performSecretQueries = async () => {
      try {
        // Consultas silenciosas a todas las tablas principales
        const queries = [
          // Tabla de productos/libros
          supabase.from('productbook').select('count', { count: 'exact', head: true }),
          
          // Tabla de biblias
          supabase.from('biblebook').select('count', { count: 'exact', head: true }),
          
          // Tabla de accesorios/things
          supabase.from('thingproduct').select('count', { count: 'exact', head: true }),
          
          // Tabla de autores
          supabase.from('authorsbook').select('count', { count: 'exact', head: true }),
          
          // Tabla de categorías
          supabase.from('categoriesbook').select('count', { count: 'exact', head: true }),
          
          // Tabla de comentarios
          supabase.from('userbook').select('count', { count: 'exact', head: true }),
          
          // Tabla de administradores
          supabase.from('dataadmin').select('count', { count: 'exact', head: true })
        ];

        // Ejecutar todas las consultas en paralelo
        const results = await Promise.allSettled(queries);
        
        // Log silencioso (solo en desarrollo)
        if (process.env.NODE_ENV === 'development') {
          const tableNames = ['productbook', 'biblebook', 'thingproduct', 'authorsbook', 'categoriesbook', 'userbook', 'dataadmin'];
          results.forEach((result, index) => {
            if (result.status === 'fulfilled') {
              console.log(`🔍 [SECRET] ${tableNames[index]}: ${result.value.count || 0} registros`);
            } else {
              console.warn(`⚠️ [SECRET] Error en ${tableNames[index]}:`, result.reason?.message);
            }
          });
        }

        // También puedes hacer consultas más específicas
        await performDetailedQueries();
        
      } catch (error) {
        // Error silencioso - no afecta la UI
        console.warn('🤫 Secret monitoring failed:', error);
      }
    };

    const performDetailedQueries = async () => {
      try {
        // Consultas más detalladas
        const detailedQueries = [
          // Productos más populares (por favoritos)
          supabase
            .from('productbook')
            .select('title_product, favorite_count_product')
            .order('favorite_count_product', { ascending: false })
            .limit(5),
          
          // Últimos productos agregados (usando id_product como orden)
          supabase
            .from('productbook')
            .select('title_product, id_product')
            .order('id_product', { ascending: false })
            .limit(3),
          
          // Estadísticas de disponibilidad
          supabase
            .from('productbook')
            .select('available_product')
            .eq('available_product', true),
        ];

        const detailedResults = await Promise.allSettled(detailedQueries);
        
        if (process.env.NODE_ENV === 'development') {
          console.log('🔍 [SECRET] Detailed monitoring completed');
        }
        
      } catch (error) {
        console.warn('🤫 Detailed monitoring failed:', error);
      }
    };

    // Ejecutar inmediatamente
    performSecretQueries();

    // Ejecutar cada 5 minutos
    const interval = setInterval(performSecretQueries, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, [enabled]);

  return null; // No retorna nada visible
};

export default useSecretMonitoring;
